import IImage from "../interfaces/IImage";
import IWebsite from "../interfaces/IWebsite";

export default class ImagesHelper {

    public static getImageUrl(image: IImage, website: IWebsite): string
    {
        return `https://${website.domain}/images/${image.fileName}`;
    }
}